import Button from "../../component/common/Button";
import { useEffect, useState } from "react";
import Price from "../../component/common/Price";
import { motion } from "framer-motion";

function BiggestDiffDetail(props) {
  const [todayArray, setTodayArray] = useState([]);
  const [lastArray, setLastArray] = useState([]);
  const [diffSaleRank, setDiffSaleRank] = useState([]);
  const [diffProfitRank, setDiffProfitRank] = useState([]);
  const [diffType, setDiffType] = useState("sale");

  //정렬 결과를 제대로 반영하기 위한 비동기 함수
  const sorting = async (arr, key, type) => {
    await arr.sort((a, b) => {
      if (a[key] === b[key]) {
        return b.lastSales - a.lastSales;
      }
      return a[key] - b[key];
    });
    if (type === "sale") {
      setDiffSaleRank([...arr].reverse());
    } else {
      setDiffProfitRank([...arr].reverse());
    }
  };

  //1. 오늘,이번주,이번달 데이터와 어제,지난주,지난달 판매데이터 가져옴
  useEffect(() => {
    if (props.rankDetailValue !== null) {
      setTodayArray(props.rankDetailValue[props.page]);
    }
    if (props.lastDetailValue !== null) {
      setLastArray(props.lastDetailValue[props.page]);
    }
  }, [props]);
  //2. 오늘 판매와 지난 판매 비교값 구하기
  useEffect(() => {
    if (todayArray.length !== 0 && lastArray.length !== 0) {
      const diffArray = [];
      //오늘 메뉴별 매출 데이터를 돌면서 어제 데이터의 매출 데이터 확인 -> obj에 추가해 diffArray에 푸쉬
      todayArray.forEach((element) => {
        const obj = {};
        const compareElement = lastArray.find(
          (item) => item.name === element.name
        );
        if (compareElement?.count === 0) {
          return;
        }
        if (compareElement !== undefined) {
          obj["name"] = element.name;
          const todayProfit = element.price;
          const lastProfit = compareElement.price;
          obj["lastSales"] = compareElement.count;
          obj["todaySales"] = element.count;
          obj["todayProfit"] = todayProfit;
          obj["lastProfit"] = lastProfit;
          obj["profitDiff"] = todayProfit - lastProfit;
          if (compareElement.count !== 0 && element.count !== 0) {
            obj["percentage"] =
              Math.round(
                ((element.count - compareElement.count) /
                  compareElement.count) *
                  100 *
                  100
              ) / 100;
          } else {
            obj["percentage"] = -100;
          }
          // if (compareElement.count === 0) {
          //   a = 1;
          // } else {
          //   a = compareElement.count;
          // }
          // if (element.count === 0) {
          //   b = 1;
          // } else {
          //   b = element.count;
          // }

          // obj["percentage"] = Math.round(((b - a) / a) * 100 * 100) / 100;
          diffArray.push(obj);
        }
      });
      //판매 갯수 변화에 따라 따라 정렬

      sorting([...diffArray], "percentage", "sale");
      sorting([...diffArray], "profitDiff", "profit");

      //sale 차이에 따라 정렬

      setDiffSaleRank(
        diffArray.sort((a, b) => a.profitDiff - b.profitDiff).reverse()
      );
    }
  }, [todayArray, lastArray]);

  function changeType(type) {
    setDiffType(type);
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="block w-[100%] px-[5%] py-10 border border-[#f3f4f6]"
      id="best-rank"
    >
      <div className="best-rank__header">
        <div className="best-rank__back-icon" onClick={props.goBack}>
          &lt;
        </div>
        <div className="best-rank__title">
          {props.page === "daily"
            ? props.t("biggestDiff.diffTitle.daily")
            : props.page === "weekly"
            ? props.t("biggestDiff.diffTitle.weekly")
            : props.page === "monthly"
            ? props.t("biggestDiff.diffTitle.monthly")
            : props.t("biggestDiff.diffTitle.daily")}
        </div>
      </div>
      <div className="best-rank__notice">
        <div className="notice">{props.t("biggestDiff.notice")}</div>
      </div>
      <div className="best-rank__button">
        <div
          className="best-rank__each-button"
          onClick={(event) => changeType("sale")}
        >
          <Button
            color={diffType === "sale" ? "black" : "white"}
            txt={props.t("biggestDiff.saleCount")}
          ></Button>
        </div>
        <div
          className="best-rank__each-button"
          onClick={(event) => changeType("profit")}
        >
          <Button
            color={diffType === "sale" ? "white" : "black"}
            txt={props.t("biggestDiff.saleProfit")}
          ></Button>
        </div>
      </div>

      <div>
        <div className="flex w-full h-10 text-[3.4vw] font-medium text-neutral-500">
          <div className="flex w-[15%] items-center justify-center border-b border-solid border-neutral-500">
            {props.t("biggestDiff.rank")}
          </div>
          <div className="flex w-[35%] items-center justify-center border-b border-solid border-neutral-500">
            {props.t("biggestDiff.menuName")}
          </div>
          <div className="flex w-[25%] items-center justify-center border-b border-solid border-neutral-500">
            {props.page === "daily"
              ? props.t("biggestDiff.lastValue.daily")
              : props.page === "weekly"
              ? props.t("biggestDiff.lastValue.weekly")
              : props.page === "monthly"
              ? props.t("biggestDiff.lastValue.monthly")
              : ""}
          </div>

          <div className="flex w-[25%] items-center justify-center border-b border-solid border-neutral-500">
            {props.page === "daily"
              ? props.t("biggestDiff.thisValue.daily")
              : props.page === "weekly"
              ? props.t("biggestDiff.thisValue.weekly")
              : props.page === "monthly"
              ? props.t("biggestDiff.thisValue.monthly")
              : ""}
          </div>
        </div>
        {diffType === "sale"
          ? diffSaleRank.map((element, index) => (
              <div
                className="best-rank__each"
                id={(index + 1) % 2 === 0 ? "even" : "odd"}
              >
                <div className="flex w-[15%] items-center justify-center text-[4vw] font-bold text-left">
                  {index + 1}
                </div>

                <div className="flex flex-col w-[35%] items-center justify-center text-[3.8vw] font-medium text-left">
                  <div className="best-rank__row__menu">{element.name}</div>
                  <div
                    className="best-rank__row__sales"
                    style={{
                      color:
                        element.percentage > 0
                          ? "red"
                          : element.percentage < 0
                          ? "blue"
                          : "grey",
                    }}
                  >
                    {element.percentage > 0
                      ? `+${element.percentage}%`
                      : element.percentage < 0
                      ? `${element.percentage}%`
                      : "-"}
                  </div>
                </div>

                <div className="flex flex-col w-[25%] items-center justify-center text-[3.8vw] font-medium text-left text-neutral-500">
                  {element.lastSales}개
                </div>
                <div className="flex flex-col w-[25%] items-center justify-center text-[3.8vw] font-medium text-left ">
                  {element.todaySales}개
                </div>
              </div>
            ))
          : diffProfitRank.map((element, index) => (
              <div
                className="best-rank__each"
                id={(index + 1) % 2 === 0 ? "even" : "odd"}
              >
                <div className="flex w-[15%] items-center justify-center text-[4vw] font-bold text-left">
                  {index + 1}
                </div>
                <div className="flex flex-col w-[35%] items-center justify-center text-[3.8vw] font-medium text-left">
                  <div className="best-rank__row__menu">{element.name}</div>
                  <div
                    className="best-rank__row__sales"
                    style={{
                      color:
                        element.profitDiff > 0
                          ? "red"
                          : element.profitDiff < 0
                          ? "blue"
                          : "grey",
                    }}
                  >
                    {element.profitDiff > 0 ? "+" : ""}
                    {element.profitDiff !== 0 ? (
                      <Price value={element.profitDiff} unit=""></Price>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
                <div className="flex flex-col w-[25%] items-center justify-center text-[3.8vw] font-medium text-left text-neutral-500">
                  <Price value={element.lastProfit} unit="원"></Price>
                </div>
                <div className="flex flex-col w-[25%] items-center justify-center text-[3.8vw] font-medium text-left">
                  <Price value={element.todayProfit} unit="원"></Price>
                </div>
              </div>
            ))}
      </div>
    </motion.div>
  );
}

export default BiggestDiffDetail;
